import { useSyncExternalStore } from "react";

/**
 * Tiny `window.matchMedia` hook backed by {@link useSyncExternalStore}. The
 * sync-store pattern is the right shape for `matchMedia`: we describe a
 * subscription (the `change` listener) and a getSnapshot (the current
 * matches state) and React handles tearing-free re-renders.
 *
 *   const isDesktop = useMediaQuery("(min-width: 768px)");
 */
export function useMediaQuery(query: string, defaultValue = false): boolean {
  const subscribe = (onStoreChange: () => void) => {
    if (typeof window === "undefined" || typeof window.matchMedia !== "function") {
      return () => undefined;
    }
    const mql = window.matchMedia(query);
    mql.addEventListener("change", onStoreChange);
    return () => mql.removeEventListener("change", onStoreChange);
  };
  const getSnapshot = (): boolean => {
    if (typeof window === "undefined" || typeof window.matchMedia !== "function") {
      return defaultValue;
    }
    return window.matchMedia(query).matches;
  };
  const getServerSnapshot = (): boolean => defaultValue;
  return useSyncExternalStore(subscribe, getSnapshot, getServerSnapshot);
}
